import React, { useState } from 'react';

// One avatar for the whole web client: the person's photo if they have set one, otherwise the first
// letter of their name in a coloured disc.
//
// 2026-09-20: replaces a random face from i.pravatar.cc, which every account was given at
// registration. It was a stranger's photograph standing in for a real person you might be about to
// meet at a kerb, and fetching it disclosed the username to a third party on every render.
const COLORS = ['#512da8', '#00796b', '#c2185b', '#f57c00', '#455a64', '#5d4037', '#0277bd', '#7b1fa2'];

const colorFor = (name = '') => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return COLORS[hash % COLORS.length];
};

const Avatar = ({ username, avatarUrl, size = 40, serverUrl, style }) => {
  const [failed, setFailed] = useState(false);
  const name = username || '';

  let src = null;
  if (avatarUrl && !failed) {
    src = avatarUrl.startsWith('http')
      ? (avatarUrl.includes('localhost') && serverUrl ? avatarUrl.replace('http://localhost:3001', serverUrl) : avatarUrl)
      : `${serverUrl || ''}${avatarUrl}`;
  }

  const box = { width: size, height: size, borderRadius: '50%', flexShrink: 0, ...style };
  if (src) {
    return <img src={src} alt={name} style={{ ...box, objectFit: 'cover' }} onError={() => setFailed(true)} />;
  }
  return (
    <div
      style={{
        ...box,
        background: colorFor(name),
        color: '#fff',
        fontWeight: 700,
        fontSize: size * 0.42,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
      }}
    >
      {(name || '?').charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;
